import { useRoute } from 'hooks/navigation/use-route';

import { ILoyaltyOffersParams } from './types';

interface ILoyaltyOffersFlow {
  offerEngineId: string;
}

// This hook should be removed when we split OfferList from OfferDetails components
const useLoyaltyOffersFlow = (): ILoyaltyOffersFlow => {
  const { params } = useRoute<ILoyaltyOffersParams>();
  const offerEngineId = (params?.offerEngineId || '').trim();

  return {
    offerEngineId,
  };
};

export default useLoyaltyOffersFlow;
